
export default {
    inheritAttrs: false,

    props: {
        // eslint-disable-next-line vue/require-default-prop
        value: null,

        size: {
            type: Number,
            default: 1,
        },

        boxSize: {
            type: String,
            default: 'h-5 w-5',
        },
        textClass: {
            type: String,
            default: 'text-sm text-general-4 font-semibold',
        },
        model: undefined,
    },

    computed: {
        radioValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
}
